<app-auth-page-layout>
  <div class="flex flex-col gap-2!">
    <h1 class="auth-title text-balance">{{ 'sign in' | translate }}</h1>
    <p class="auth-subtitle text-pretty">{{ 'sign in welcome' | translate }}</p>
  </div>

  <div class="grid grid-cols-2 gap-3!">
    <button type="button" class="auth-social-btn">
      <img src="/assets/images/svgs/google-icon.svg" alt="" aria-hidden="true" width="18" />
      Google
    </button>
    <button type="button" class="auth-social-btn">
      <img src="/assets/images/svgs/microsoft-icon.svg" alt="" aria-hidden="true" width="20" />
      Microsoft
    </button>
  </div>

  <div class="flex items-center gap-3.5!">
    <div class="grow h-px bg-[#dde2de]"></div>
    <span class="text-[13px] text-[#56625a]">{{ 'or sign in with email' | translate }}</span>
    <div class="grow h-px bg-[#dde2de]"></div>
  </div>

  @if (showServerError) {
    <div role="alert" class="auth-alert">
      <mat-icon class="auth-alert-icon" aria-hidden="true">error_outline</mat-icon>
      <p class="m-0! text-sm leading-normal">{{ 'wrong email or password' | translate }}</p>
    </div>
  }

  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate class="flex flex-col gap-5!">
    <div class="flex flex-col gap-2!">
      <label for="email" class="auth-label">{{ 'email' | translate }}</label>
      <input id="email"
             type="email"
             autocomplete="email"
             formControlName="email"
             class="auth-input"
             [class.auth-input-invalid]="isInvalid('email')"
             [attr.aria-invalid]="isInvalid('email')"
             [placeholder]="'enter your email address' | translate"/>
      @if (isInvalid('email') && !hasError('email', 'serverError')) {
        <p class="auth-error"><mat-icon class="auth-error-icon" aria-hidden="true">error_outline</mat-icon>{{ (hasError('email', 'required') ? 'email required' : 'email invalid') | translate }}</p>
      }
    </div>

    <div class="flex flex-col gap-2!">
      <div class="flex justify-between items-baseline gap-3!">
        <label for="password" class="auth-label">{{ 'password' | translate }}</label>
        <a routerLink="/forgot-password" class="auth-link text-[13px]">{{ 'forgot password' | translate }}</a>
      </div>
      <div class="relative">
        <input id="password"
               [type]="showPassword ? 'text' : 'password'"
               autocomplete="current-password"
               formControlName="password"
               class="auth-input pr-[52px]!"
               [class.auth-input-invalid]="isInvalid('password')"
               [attr.aria-invalid]="isInvalid('password')"/>
        <button type="button"
                class="auth-icon-btn absolute top-0.5 right-0.5 w-11 h-11"
                [attr.aria-label]="(showPassword ? 'hide password' : 'show password') | translate"
                (click)="showPassword = !showPassword">
          <i-tabler [name]="showPassword ? 'eye-off' : 'eye'" class="icon-20 d-flex" />
        </button>
      </div>
      @if (isInvalid('password') && !hasError('password', 'serverError')) {
        <p class="auth-error"><mat-icon class="auth-error-icon" aria-hidden="true">error_outline</mat-icon>
          @if (hasError('password', 'required')) {
            {{ 'password required' | translate }}
          } @else {
            {{ 'password length must not exceed' | translate: { length: passwordMaxLength } }}
          }
        </p>
      }
    </div>

    <label class="auth-checkbox">
      <input type="checkbox" />
      {{ 'keep me signed in' | translate }}
    </label>

    <button type="submit" class="auth-btn auth-btn-primary" [disabled]="spinLoader" [attr.aria-busy]="spinLoader">
      @if (spinLoader) {
        <span class="loading-container"><mat-icon>hourglass_empty</mat-icon></span>
      }
      {{ 'sign in' | translate }}
    </button>
  </form>

  <p class="m-0! text-sm text-[#56625a]">
    {{ 'new to gfli' | translate }}
    <a routerLink="/register" class="auth-link">{{ 'create an account' | translate }}</a>
  </p>

  <router-outlet />
</app-auth-page-layout>
